<div [formGroup]="form">
  <pr-input [label]="'Label'" [derrors]="derrors"
    ><input formControlName="label" type="text"
  /></pr-input>
  <pr-input [label]="'Prix d\'achat'" [derrors]="derrors" suffix="€"
    ><input formControlName="purchasePrice" type="text"
  /></pr-input>

  <pr-input-date
    formControlName="startDate"
    label="Date d'achat"
    [derrors]="derrors"
  ></pr-input-date>

  <pr-input-maps
    (placeChanged)="toValue = $event"
    placeholder="Enter to address..."
    label="Adresse du bien"
    formGroupName="address"
    [isGMaps]="isGMaps"
    [countries]="countries"
    [derrors]="derrors"
  ></pr-input-maps>

  <!-- <pr-input label="Type de résidence" [derrors]="derrors"
    [hidden]="parentForm && ['LAND', 'SURFACE', 'GARAGE'].includes(parentForm.get('personalUseType').value)">
    <mat-select formControlName="residenceType">
      <mat-option value="APPARTMENT">{{ 'pages.realEstate.appartment' | translate }}</mat-option>
      <mat-option value="HOUSE">{{ 'pages.realEstate.house' | translate }}</mat-option>
    </mat-select>
  </pr-input> -->

  <pr-input [label]="'Surface'" [derrors]="derrors" suffix="m²"
    ><input formControlName="areaSize" type="text" />
  </pr-input>

  <!--<pr-input label="Acquis au travers de" [derrors]="derrors">
    <mat-select formControlName="subscriptionSource">
      <mat-option *ngFor="let item of subscriptionSource" [value]="item.id">
        {{ item.value | translate }}
      </mat-option>
    </mat-select>
  </pr-input>

  <pr-input-owner formControlName="owners" [derrors]="derrors" ></pr-input-owner> -->
  <div></div>
</div>
